<template>
    <div class="col-md-12 mx-auto">
        <div class="card mt-12">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">График</div>
            </div>

            <div class="card-body">

                <div class="button-goup">
                    <button type="button" class="btn btn-primary"
                            data-toggle="tooltip"
                            title="Презареди"
                            @click.stop="schedulerRefresh">
                        <i class="fas fa-sync-alt"></i>
                    </button>
                </div>
                <kendo-schedulerdatasource ref="schedulerDataSource"
                                           :transport="shedulerTransportSettings"
                                           :schema-data="'items'"
                                           :schema-model-id="'taskId'"
                                           :schema-model-fields="scheduleSchemaModelFields"
                                           :error="dataSourceError"
                                           :requestEnd="datasorceRequestEnd">
                </kendo-schedulerdatasource>

                <kendo-scheduler ref="scheduler"
                                 data-source-ref="schedulerDataSource"
                                 :date="initialDate"
                                 :height="auto"
                                 :group="group"
                                 :start-time="startWorkingTime"
                                 :end-time="endWorkingTime"
                                 :event-template="eventTaskTemplate"
                                 :group-header-template="groupHeaderTemplate"
                                 :all-day-slot="allDaySlot"
                                 :timezone="'Etc/UTC'"
                                 :toolbar="['pdf']"
                                 :pdf-file-name="pdfExportFileName"
                                 :views="schedulerViews"
                                 @resize="onResize"
                                 @resizeend="onResizeEnd"
                                 @move="onMove"
                                 @moveend="onMoveEnd"
                                 @add="onAdd"
                                 @save="onSave"
                                 @navigate="onNavigate"
                                 @edit="onEdit">
                    <kendo-scheduler-resource :field="'placeId'" :name="'Places'" :title="'Place'" :data-source="placesDataSource"></kendo-scheduler-resource>
                    <kendo-scheduler-resource :field="'hallId'" :name="'Halls'" :title="'Hall'" :data-source="hallsDataSource"></kendo-scheduler-resource>
                    <!--<kendo-scheduler-resource :field="'eventId'" :name="'Events'" :title="'Event'" :data-source="eventsDataSource"></kendo-scheduler-resource>
                    <kendo-scheduler-resource :field="'lecturers'" :name="'Lecturers'" :title="'Lecturers'" :multiple="lecturersSettings.multiple" :data-source="lecturersDataSource"></kendo-scheduler-resource>-->
                </kendo-scheduler>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import EventTaskTemplate from "../../../components/scheduler/EventTaskTemplate";
    import GroupHeaderTemplate from "../../../components/scheduler/GroupHeaderTemplate";
    import { SchedulerInstaller } from '@progress/kendo-scheduler-vue-wrapper'

    Vue.use(SchedulerInstaller)

    kendo.pdf.defineFont({
        "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
        "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    });


    export default {
        components: {

        },
        props: {
            eventId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                name: 'PlacesScheduler',
                initialDate: new Date(),
                startWorkingTime: new Date("2019/7/15 07:00 AM"),// Начален час на показване // new Date(this.initialDate.getFullYear(), this.initialDate.getMonth(), this.initialDate.getDate(), 7, 0, 0),
                endWorkingTime: new Date("2019/7/15 08:00 PM"), // Краен час на показване // new Date(this.initialDate.getFullYear(), this.initialDate.getMonth(), this.initialDate.getDate(), 7, 0, 0),
                schedulerViews: [
                    { type: "day", selected: true },
                    { type: "workWeek", selected: false },
                    { type: "week", selected: false },
                    { type: "month", selected: false },
                    { type: "agenda", selected: false }
                ],
                allDaySlot: true,
                lecturersSettings: {
                    multiple: true
                },
                eventTemplate: '<div class="movie-template"><p>#: kendo.toString(start, "hh:mm") # - #: kendo.toString(end, "hh:mm") #</p> <h3>#: title #</h3><a href="#= imdb #" target="_blank">Movie in IMDB</a></div>',
                scheduleSchemaModelFields: {
                    taskId: { name: 'taskId', from: 'id', type: "number" },
                    title: { name: 'title', from: 'title', defaultValue: "Enter title", validation: { required: true } },
                    capacity: { name: 'capacity', from: 'capacity', type: "number" },
                    description: { name: 'description', from: 'description', type: "string", nullable: true },
                    participants: { name: 'participants', from: 'participants', type: "number", nullable: true, validation: { min: 1 } },
                    hallId: { name: 'hallId', from: 'hallId', type: "number", nullable: true },
                    placeId: { name: 'placeId', from: 'placeId', type: "number", nullable: true },
                    eventId: { name: 'eventId', from: 'eventId', type: "number", nullable: true },
                    start: { name: 'start', from: 'start', type: "date" },
                    end: { name: 'end', from: 'end', type: "date" },
                    lecturers: { name: 'lecturers', from: 'lecturers', defaultValue: 1 },
                    isAllDay: { name: 'isAllDay', from: 'isAllDay', type: "boolean" }
                },
                placeSchemaModelFields: {
                    placeId: { name: 'placeId', from: 'id', type: "number", nullable: false },
                    value: { name: 'value', from: 'id', type: "number", nullable: false },
                    text: { name: 'text', from: 'text', type: "string", nullable: true },
                    color: { name: 'color', from: 'color', type: "string", nullable: true },
                },
                hallSchemaModelFields: {
                    hallId: { name: 'hallId', from: 'id', type: "number", nullable: false },
                    value: { name: 'value', from: 'parentId', type: "number", nullable: true },
                    parentId: { name: 'parentId', from: 'parentId', type: "number", nullable: true },
                    text: { name: 'text', from: 'text', type: "string", nullable: true },
                    color: { name: 'color', from: 'color', type: "string", nullable: true },
                },
                group: {
                    //resources: ["Halls", "Lectors"],
                    resources: ["Halls"],
                    orientation: "vertical" /*horizontal,vertical*/
                },
                placesDataSource: {
                    transport: {
                        read: {
                            url: this.$store.getters.baseUrl + '/api/placesScheduler/schedulerPlaces/',
                            dataType: 'json',
                            type: 'GET',
                            contentType: 'application/json',
                            beforeSend: this.beforeSend
                        }
                    },
                    requestEnd: this.datasorceRequestEnd
                },
                hallsDataSource: {
                    transport: {
                        read: {
                            url: this.$store.getters.baseUrl + '/api/placesScheduler/schedulerHalls/',
                            dataType: 'json',
                            type: 'GET',
                            data: {
                                placeId: this.eventId
                            },
                            contentType: 'application/json',
                            beforeSend: this.beforeSend
                        }
                    },
                    requestEnd: this.datasorceRequestEnd
                },
                //lecturersDataSource: {
                //    transport: {
                //        read: {
                //            url: this.$store.getters.baseUrl + '/api/placesScheduler/lecturers',
                //            dataType: 'json',
                //            type: 'GET',
                //            contentType: 'application/json',
                //            beforeSend: this.beforeSend
                //        }
                //    },
                //    requestEnd: this.datasorceRequestEnd
                //},
                //eventsDataSource: {
                //    transport: {
                //        read: {
                //            url: this.$store.getters.baseUrl + '/api/placesScheduler/events',
                //            dataType: 'json',
                //            type: 'GET',
                //            contentType: 'application/json',
                //            beforeSend: this.beforeSend
                //        }
                //    },
                //    requestEnd: this.datasorceRequestEnd
                //},
                shedulerTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/placesScheduler/sourcenew/',
                        dataType: 'json',
                        type: 'POST',
                        data: {
                            eventId: this.eventId
                        },
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    create: {
                        url: this.$store.getters.baseUrl + '/api/placesScheduler/create',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    update: {
                        url: this.$store.getters.baseUrl + '/api/placesScheduler/update',
                        dataType: 'json',
                        type: 'PUT',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    destroy: {
                        url: this.$store.getters.baseUrl + '/api/placesScheduler/delete',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                //placesTransportSettings: {
                //    read: {
                //        url: this.$store.getters.baseUrl + '/api/places/schedulerPlaces/',
                //        dataType: 'json',
                //        type: 'GET',
                //        contentType: 'application/json',
                //        beforeSend: this.beforeSend
                //    },
                //    parameterMap: this.parameterMap
                //},
                //hallsTransportSettings: {
                //    read: {
                //        url: this.$store.getters.baseUrl + '/api/places/schedulerHalls/',
                //        dataType: 'json',
                //        type: 'GET',
                //        data: {
                //            placeId: this.eventId
                //        },
                //        contentType: 'application/json',
                //        beforeSend: this.beforeSend
                //    },
                //    parameterMap: this.parameterMap
                //}
            };
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    return kendo.stringify(options);
                }
            },
            onResize(e) {
                if (this.hallIsOccupied(e.start, e.end, e.event, e.resources) || this.lectorIsOccupied(e.start, e.end, e.event, e.resources)) {
                    e.sender.wrapper.find(".k-marquee-color").addClass("invalid-slot");
                    e.preventDefault();
                }
            },
            onResizeEnd(e) {
                if (!this.checkAvailability(e.start, e.end, e.events)) {
                    e.preventDefault();
                }
            },
            onMove(e) {
                if (this.hallIsOccupied(e.start, e.end, e.event, e.resources) || this.lectorIsOccupied(e.start, e.end, e.event, e.resources)) {
                    e.sender.wrapper.find(".k-event-drag-hint").addClass("invalid-slot");
                }
            },
            onMoveEnd(e) {
                if (!this.checkAvailability(e.start, e.end, e.event, e.resources)) {
                    e.preventDefault();
                }
            },
            onAdd(e) {
                if (!this.checkAvailability(e.event.start, e.event.end, e.event)) {
                    e.preventDefault();
                }
            },
            onSave(e) {
                if (!this.checkAvailability(e.event.start, e.event.end, e.event)) {
                    e.preventDefault();
                }

                if (e.event.lecturers.length === undefined) {
                    e.event.lecturers = [e.event.lecturers]
                }
            },
            onNavigate(e) {
                //Fired when the user changes the selected date, or view of the scheduler

                /* EVENT DATA
                e.action String
                Name of the action. Possible values are:

                changeView - navigate to different view
                next - navigate to next time period
                previous - navigate to previous time period
                today - select today's date
                changeDate - a date is selected via the Calendar
                e.date Date
                Selected date

                e.view String
                Name of the view

                e.preventDefault Function
                If invoked prevents the action.

                e.sender kendo.ui.Scheduler
                The widget instance which fired the event. */

                if (e.action === 'changeView') {
                    for (var i = 0; i < this.schedulerViews.length; i++) {
                        if (this.schedulerViews[i].hasOwnProperty('type')
                            && this.schedulerViews[i].hasOwnProperty('selected')) {
                            this.schedulerViews[i].selected = this.schedulerViews[i].type === e.view;
                        }
                    }
                    //for (const key in this.schedulerViews) {
                    //    if (this.schedulerViews.hasOwnProperty(key)) {
                    //        this.schedulerViews[key].selected = e.view === key
                    //    }
                    //}
                }

                this.initialDate = e.date;
            },
            onEdit(e) {
                var ddl = $('input[title="Recurrence editor"]').data('kendoDropDownList')
                if (ddl) {
                    var data = ddl.dataSource.data();
                    data = data.slice(0, 4);
                    ddl.setDataSource(data)
                }
            },
            occurrencesInRangeByResource: function (start, end, resourceFieldName, event, resources) {
                var scheduler = this.$refs.scheduler.kendoWidget();

                var occurrences = scheduler.occurrencesInRange(start, end);

                var idx = occurrences.indexOf(event);
                if (idx > -1) {
                    occurrences.splice(idx, 1);
                }

                event = $.extend({}, event, resources);

                return this.filterByResource(occurrences, resourceFieldName, event[resourceFieldName]);
            },
            filterByResource: function (occurrences, resourceFieldName, value) {
                var result = [];
                var occurrence;

                for (var idx = 0, length = occurrences.length; idx < length; idx++) {
                    occurrence = occurrences[idx];
                    if (occurrence[resourceFieldName] === value) {
                        result.push(occurrence);
                    }
                }
                return result;
            },
            lectorIsOccupied(start, end, event, resources) {
                var occurrences = this.occurrencesInRangeByResource(start, end, "attendee", event, resources);
                if (occurrences.length > 0) {
                    return true;
                }
                return false;
            },
            hallIsOccupied: function (start, end, event, resources) {
                var occurrences = this.occurrencesInRangeByResource(start, end, "roomId", event, resources);
                if (occurrences.length > 0) {
                    return true;
                }
                return false;
            },
            checkAvailability: function (start, end, event, resources) {
                if (this.lectorIsOccupied(start, end, event, resources)) {
                    setTimeout(function () {
                        alert("This person is not available in this time period.");
                    }, 0);

                    return false;
                }

                if (this.hallIsOccupied(start, end, event, resources)) {
                    setTimeout(function () {
                        alert("This room is not available in this time period.");
                    }, 0);

                    return false;
                }

                return true;
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            datasorceRequestEnd(e) {
                if (e.type == "create" && e.response) {
                    e.sender.read()

                    this.$vs.notify({
                        title: '',
                        text: e.response && e.response.message ? e.response.message : this.$t('createSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                } else if (e.type == "update" && e.response) {
                    e.sender.read()

                    this.$vs.notify({
                        title: '',
                        text: e.response && e.response.message ? e.response.message : this.$t('updateSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }
                else if (e.type == "destroy" && e.response) {
                    e.sender.read()

                    this.$vs.notify({
                        title: '',
                        text: e.response && e.response.message ? e.response.message : this.$t('updateSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }
            },
            schedulerRefresh() {
                this.$refs.scheduler.kendoWidget().dataSource.transport.options.read.data = { placeId: this.placeId };
                this.$refs.scheduler.kendoWidget().dataSource.read();
            },
            schedulerReload() {
                let scheduler = this.$refs.scheduler.kendoWidget();
                for (var i = 0; i < scheduler.resources.length; i++) {
                    let res = scheduler.resources[i]
                    if (res.hasOwnProperty('name') && res['name'] === 'Halls') {
                        res.dataSource.transport.options.read.data = { placeId: this.placeId }

                        res.dataSource.read();
                    }
                }

                this.$refs.scheduler.kendoWidget().dataSource.transport.options.read.data = { placeId: this.placeId };
                this.$refs.scheduler.kendoWidget().dataSource.read();
                this.$refs.scheduler.kendoWidget().refresh();
            },
            eventTaskTemplate: function (e) {
                return {
                    template: Vue.component(EventTaskTemplate.name, EventTaskTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.map
                    }
                };
            },
            groupHeaderTemplate: function (e) {
                return {
                    template: Vue.component(GroupHeaderTemplate.name, GroupHeaderTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.map
                    }
                };
            }
        },
        watch: {

        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            pdfExportFileName() {
                return "Scheduler_Export.pdf";
            }
        },
        mounted() {
            //this.loadHalls();
            //this.loadLectors();
        }
    }
</script>

<style scoped>
    .invalid-slot {
        background: red !important;
        cursor: no-drop;
    }

    /* Hide toolbar, navigation and footer during export */
    .k-pdf-export .k-scheduler-toolbar,
    .k-pdf-export .k-scheduler-navigation .k-nav-today,
    .k-pdf-export .k-scheduler-navigation .k-nav-prev,
    .k-pdf-export .k-scheduler-navigation .k-nav-next,
    .k-pdf-export .k-scheduler-footer {
        display: none;
    }

    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: "DejaVu Sans", "Arial", sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit, .k-grid-details, .k-grid-delete, .k-grid-pdf, .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>
